<script setup lang="ts">
import { ref } from 'vue'

const navItems = [
  { label: 'Dashboard', icon: 'pi pi-gauge', to: '/admin/home/' },
  { label: 'Media', icon: 'pi pi-images', to: '/admin/media/' },
  { label: 'Strony', icon: 'pi pi-copy', to: '/admin/pages/' },
  { label: 'Aktualności', icon: 'pi pi-copy', to: '/admin/aktualnosci/' },
  { label: 'Użytkownicy', icon: 'pi pi-users', to: '/admin/users/' },
  { label: 'Ustawienia', icon: 'pi pi-cog', to: '/admin/settings/' },
  { label: 'Kopie zapasowe', icon: 'pi pi-cog', to: '/admin/backups/' }
]

const collapsed = ref(false)
</script>

<template>
  <div
    :style="{ width: collapsed ? '2.5rem' : '10rem', height: 'calc(100vh - 32px)' }"
    class="flex flex-col bg-cms-dark-gray overflow-hidden text-nowrap transition-[width] duration-300 ease-in-out"
  >
    <nav class="flex flex-col py-2 flex-1">
      <NuxtLink
        v-for="item in navItems"
        :key="JSON.stringify(item)"
        :to="item.to"
        class="cursor-pointer h-8 flex items-center gap-3 px-2 py-2 hover:bg-cms-blue transition-colors border-l-2 border-transparent"
        active-class="bg-cms-blue border-l-blue-300"
      >
        <i :class="[item.icon, 'w-5 shrink-0 text-center text-white']" />
        <span
          class="overflow-hidden transition-[opacity,max-width] duration-300 ease-in-out text-admin-menu"
          :style="{ maxWidth: collapsed ? '0' : '10rem', opacity: collapsed ? 0 : 1 }"
        >{{ item.label }}</span>
      </NuxtLink>
    </nav>

    <button
      class="cursor-pointer flex items-center gap-2 px-2 py-2 border-t border-white/10 transition-colors overflow-hidden"
      @click="collapsed = !collapsed"
    >
      <i
        :class="collapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"
        class="shrink-0 transition-transform duration-300 text-white"
      />
      <span
        class="overflow-hidden transition-[opacity,max-width] duration-300 ease-in-out text-admin-menu"
        :style="{ maxWidth: collapsed ? '0' : '10rem', opacity: collapsed ? 0 : 1 }"
      >Collapse menu</span>
    </button>
  </div>
</template>
